import { WxDrawingElement } from './wx-drawing-element';
import { WxConnectionVO } from '@article/model/vo/wx-article.vo';
import { NumberUtils } from '@shared/util/number-utils';
import { ArrayUtils } from '@shared/util/array-utils';

export class WxConnectionElement {
  public active: boolean;
  public connected: boolean
  public connectionId: number;
  public connectionOrder: number;
  public coordinateX: number;
  public coordinateY: number;
  public coordinateZ: number;
  public corridor: number;
  public description: string;
  public direction: boolean;
  public drawing: boolean;
  public first: boolean;
  public last: boolean;
  public groupDescription: string;
  public measure: boolean;
  public middle: boolean;
  public optional: boolean;
  public rotationX: number;
  public rotationY: number;
  public rotationZ: number;
  public turnable: boolean;
  public typeDescription: string;
  public typeId: number;
  public level: number;
  public drawingElements: WxDrawingElement[] = [];
  public poleIndex: number = 0;
  public rgb1: number = 0;

  public constructor(element: WxConnectionVO) {
    this.active = element.active;
    this.connected = element.connected;
    this.connectionId = element.connectionId;
    this.connectionOrder = element.connectionOrder;
    this.coordinateX = element.coordinateX;
    this.coordinateY = element.coordinateY;
    this.coordinateZ = element.coordinateZ;
    this.corridor = element.corridor;
    this.description = element.description;
    this.direction = element.direction;
    this.drawing = element.drawing;
    this.first = element.first;
    this.last = element.last;
    this.groupDescription = element.groupDescription;
    this.measure = element.measure;
    this.middle = element.middle;
    this.optional = element.optional;
    this.rotationX = element.rotationX;
    this.rotationY = element.rotationY;
    this.rotationZ = element.rotationZ;
    this.turnable = element.turnable;
    this.typeDescription = element.typeDescription;
    this.typeId = element.connectionTypeId;
    this.level = element.level;
    if (NumberUtils.isNumber(element.rgb1) && element.rgb1 > 0) {
      this.rgb1 = element.rgb1;
    }

    if (ArrayUtils.isNotEmpty(element.drawingElements)) {
      for (const drawingElement of element.drawingElements) {
        const de: WxDrawingElement = new WxDrawingElement(drawingElement);
        if (this.rgb1 > 0) {
          de.rgb1 = this.rgb1;
        }
        this.drawingElements.push(de);
      }
    }
  }
}
